import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { get } from 'lodash';
import { repairTypeEnum, historyActionEnum } from '@modules/repairs/_repairsEnums';
import Downloader from '@components/form/Downloader/Downloader';
import { formatToDecimals } from '@utils/utils';

export default [
  {
    label: 'Vozidlo',
    field: 'vehicle.name',
    displayField: 'vehicle',
    mapper: parent => get(parent, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Typ oprava/údržba',
    field: 'type.id',
    displayField: 'type',
    type: ColumnType.ENUM,
    enum: repairTypeEnum,
    width: 200
  },
  {
    label: 'Datum opravy/údržby',
    field: 'repairTime',
    type: ColumnType.DATETIME,
    width: 200
  },
  {
    label: 'Popis závady',
    field: 'reportDescription',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Popis opravy/údržby',
    field: 'repairDescription',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Cena s DPH',
    field: 'price',
    type: ColumnType.NUMBER,
    width: 200,
    mapper: v => formatToDecimals(v)
  }
];

const NOTE_LENGTH = 30;

export const repairsHistoriesColumns = [
  {
    label: 'Text záznamu',
    field: 'note',
    displayField: 'note',
    mapper: note => (note && note.length > NOTE_LENGTH ? note.substring(0, NOTE_LENGTH - 3) + '...' : note),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Akce s opravou/údržbou',
    field: 'action',
    type: ColumnType.ENUM,
    enum: historyActionEnum,
    width: 200
  },
  {
    label: 'Uživatel, který akci provedl',
    field: 'employee.fullName',
    displayField: 'employee',
    mapper: parent => get(parent, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  }
];

export const repairsInvoicesColumns = [
  {
    label: 'Název',
    type: ColumnType.JSX,
    width: 200,
    jsx: Downloader
  }
];



// WEBPACK FOOTER //
// ./src/modules/repairs/_repairsColumns.ts